export default {
  aggregates: {
    aggregated: 'Résultats agrégés',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'il y a',
    from: 'à partir de',
    since: 'depuis',
    unit: {
      DAY: 'jour|jours',
      MONTH: 'mois|mois',
      YEAR: 'année|années'
    },
    untilNow: "jusqu'à maintenant"
  },
  categoryDetails: {
    average: 'Valeur moyenne:',
    chartLabel: {
      noLabel: 'Non',
      yesLabel: 'Oui'
    },
    description:
      "Cela montre comment les réponses de l'équipe à toutes les questions de la catégorie sont réparties.",
    hideOwnAnswers: 'Cacher ses propres réponses',
    noResponses: 'Aucune réponse',
    notParticipating: "Vous n'avez pas répondu à ces questions vous-même.",
    numberOfPeople: 'Respondés:',
    sensitiveQuestion: "Ce résultat n'est pas visible pour vos collègues.",
    showFollowUpQuestions: 'Afficher les questions de suivi',
    toggleButton: {
      overview: 'Aperçu',
      questions: 'Questions'
    },
    tooltip: {
      barValue: 'aucun | {count} personne | {count} personnes',
      barValueAnswers: 'aucun | {count} réponse | {count} réponses'
    },
    workWith: 'Améliorer {categoryName}',
    yourResponse: 'Votre réponse:'
  },
  error: {
    couldNotLoadAggregates: 'Impossible de charger des résultats agrégés.',
    couldNotLoadResults: 'Impossible de charger les résultats.',
    networkError:
      "Il y a eu un problème pour télécharger les données à partir d'internet. Votre connexion est-elle active ?",
    unknown: 'Il y a une erreur inconnue'
  },
  errors: {
    status: {
      BadRequest: 'Demande incorrecte envoyée au serveur',
      Forbidden: "L'accès à cette ressource est interdit.",
      InternalServerError:
        "Une erreur inconnue est survenue. Un problème est survenu sur le serveur. Veuillez contacter l'assistance si le problème persiste",
      NotFound: "Vous n'avez pas trouvé ce que vous cherchiez ?",
      Unauthorized: "Vous n'êtes pas autorisé à accéder à cette ressource",
      UnknownError: 'Une erreur inconnue est survenue.'
    }
  },
  freetext: {
    loadResponses: 'Charger les réponses',
    noFreeTextQuestions:
      'Lorsque votre enquête comporte des questions ouvertes, vous pouvez trouver toutes les réponses ici.',
    notEnoughResponses: 'Réponse insuffisante.',
    responses: 'Aucune réponse|{count} réponse | {count} réponses'
  },
  general: {
    add: 'Ajouter',
    cancel: 'Annuler',
    entireOrganization: "L'ensemble de l'organisation",
    ok: 'OK'
  },
  groupsComparison: {
    averageForItem:
      '{value} est la valeur moyenne des questions de {title}. {compareToBenchmark}',
    currentValue: 'Valeur actuelle',
    filter: {
      findGroups: 'Trouver des groupes',
      shouldExportWithHierarchy: 'Inclure les groupes sous-jacents'
    },
    loadMore: 'Charger plus',
    loadMoreInGroup: 'Charger plus sous {groupName}',
    noone: "Personne n'a répondu",
    noResults:
      'Pas assez de réponses pour ce groupe. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'ont répondu',
    nps: 'Net Promoter Score',
    nps_detractors: 'Detractors',
    nps_passives: 'Passives',
    nps_promoters: 'Promoters',
    questions: 'Questions dans la catégorie',
    showTrend: 'Afficher la modification',
    violationsIn:
      "Des rapports ont été effectués signalant que des violations s'étaient produites au sein du groupe {groupName}. Veuillez s'il vous plaît contacter le département des ressources humaines qui pourra vous en dire plus et vous aider à faire avancer le dossier."
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected:
        "Sélectionnez une date comme point de départ de l'historique.",
      selectDate: "Affiche l'historique des enquêtes depuis {date}.",
      selectedDate: "Affichage de l'historique des enquêtes depuis {date}."
    },
    selectorOptions: {
      custom: 'personnaliser',
      oneMonth: '1 m',
      oneYear: '12 m',
      sixMonths: '6 m'
    }
  },
  loading: {
    error: {
      link: 'Essayez à nouveau'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Enquêtes actuelles',
    help: 'Aide',
    myActivities: 'Actions',
    ourResults: 'Résultats',
    overview: 'Aperçu',
    team: 'Équipe',
    welcome: 'Bienvenue'
  },
  page: {
    results: 'Tous les résultats'
  },
  resultDetails: {
    backToResults: 'Retour en arrière',
    exportData: 'Exporter',
    exportModal: {
      includeSensitiveQuestions: 'Inclut des questions sensibles',
      loadingMessage:
        "Préparation des données pour l'exportation en cours, attendez un moment !",
      saveAsExcelAllGroupsDescription:
        "En exportant vers Excel, vous obtiendrez un fichier contenant les résultats pour {groupTitle} ainsi que tous les groupes sous-jacents. C'est utile si vous souhaitez effectuer vos propres analyses ou calculs multi-groupes.",
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        "En exportant vers Excel, vous obtiendrez un fichier contenant les résultats pour {groupTitle}{segmentInfo}. C'est utile si vous souhaitez effectuer vos propres analyses ou calculs.",
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Vous obtiendrez un document PDF contenant les résultats pour toutes les catégories et toutes les questions pour le groupe sélectionné. Utile lorsque vous souhaitez imprimer les résultats.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        "Une exportation PowerPoint vous permettra d'obtenir une présentation claire contenant les résultats pour {groupTitle}{segmentInfo}. Idéal lorsque vous devez présenter des résultats à un large public sur grand écran."
    },
    notes: {
      draggable: {
        explanation: 'Visible uniquement pour vous',
        placeholder:
          "Écrivez ici vos propres notes, commentaires et réflexions sur l'enquête",
        title: 'Notes personnelles'
      },
      status: {
        initial: 'Enregistrement automatique en cours de frappe',
        saved: 'Changements sauvegardés !',
        unsaved: 'Enregistrement proche...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Le nombre de réponses est insuffisant pour afficher les résultats par utilisateur.'
        },
        description: {
          high: 'Une personne a répondu et son score moyen est devenu vert. {count} personnes ont répondu et leur score moyen est devenu vert.',
          low: 'Une personne a répondu et son score moyen est devenu rouge. {count} personnes ont répondu et leur score moyen est devenu rouge.',
          medium:
            'Une personne a répondu et son score moyen est devenu jaune. {count} personnes ont répondu et leur score moyen est devenu jaune.'
        },
        title: 'Personne|Une personne|{count} personnes'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Votre score est le même que celui du Pulsᐩ benchmark® pour {title}.',
        higherThanBenchmarkValue:
          'Votre score est {benchmarkDiff} plus élevé que le Pulsᐩ benchmark® pour {title} qui correspond à {benchmarkValue}. Bravo !',
        lowerThanBenchmarkValue:
          'Votre score est {benchmarkDiff} inférieur au Pulsᐩ benchmark® pour {title} qui correspond à {benchmarkValue}.',
        percentagePoints: 'Points de pourcentage'
      },
      enps: {
        button: {
          description:
            "Vous serez dirigé vers notre partenaire, EQI, en charge de collecter des données de benchmarking pour un grand nombre d'organisations et de fournir des informations plus détaillées sur votre propre score eNPS.",
          title: "Comparez votre score eNPS avec celui d'autres organisations"
        }
      },
      toggleButton: {
        history: 'Historique',
        overview: 'Aperçu'
      }
    }
  },
  results: {
    aggregated: 'Agrégé',
    chooseSurvey: 'Sélectionner une enquête',
    finished: 'Complet',
    published: 'En cours'
  },
  resultsmessages: {
    disclaimer: "Pulsᐩ AI utilise l'IA générative et peut faire des erreurs.",
    error: {
      generic: 'Oh oh... il y a un problème. Veuillez rafraîchir la page.',
      notEnoughResults:
        "Il n'y a aucun résultat notable. Veuillez sélectionner un autre groupe ou une autre enquête à utiliser avec Pulsᐩ AI."
    },
    moreInfo: 'Découvrez comment utiliser Pulsᐩ AI à titre de leader',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Poser une question concernant les résultats...',
    reload: 'Rafraîchir la page',
    report: 'Signaler un problème',
    send: 'Envoyer',
    suggestionHeader:
      'Voici quelques suggestions de questions que vous pouvez poser :',
    suggestions: {
      groupsComparison: {
        1: 'Sur quels groupes dois-je me concentrer ?',
        2: 'Y a-t-il une question sur laquelle la plupart des groupes devraient travailler ?',
        3: 'Quels groupes présentent des tendances négatives ?',
        4: 'Quels groupes présentent des tendances positives ?',
        5: 'Quels groupes se démarquent négativement ?',
        6: 'Quels groupes ont besoin de mon attention ?',
        7: 'Que dois-je faire en premier ?'
      },
      overview: {
        1: 'Comment dois-je utiliser nos résultats ?',
        2: 'Comment dois-je présenter le résultat à mon équipe ?',
        3: "Dans l'ensemble, à quoi ressemblent les résultats ?",
        4: 'Quelles sont les trois principales mesures que nous devrions prendre ?',
        5: 'Que puis-je améliorer dans mon leadership ?',
        6: 'Quels sont les risques que nous encourons ?',
        7: "Que pourrait-il se passer si nous n'agissons pas ?",
        8: 'Quelles sont les priorités ?',
        9: 'Quelles sont les prévisions pour mon équipe ?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Tout le monde'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Comparer'
        },
        export: {
          title: 'Exporter'
        },
        freetext: {
          title: 'Texte libre'
        },
        results: {
          title: "Résultats de l'enquête"
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      "Impossible d'afficher les statistiques sans risquer de perdre l'anonymat.",
    others: 'Autre | Autres',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administration',
    currentSurveys: 'Sondages en cours',
    dashboard: 'Tableau de bord',
    help: 'Aide',
    logOut: 'Se déconnecter',
    myActivities: 'Mes mesures',
    ourResults: 'Nos résultats'
  },
  topbanner: {
    preview: {
      body: "Vous êtes maintenant sur la nouvelle version de l'affichage des résultats Pulsᐩ, qui comporte de nombreuses améliorations ! Si vous rencontrez un problème ou si vous avez des commentaires, n'hésitez pas à nous en faire part ! Si vous le souhaitez, vous pouvez également revenir à l'ancienne version.",
      header: 'Nouvelle version !'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Pendant la période {StartDate} - {EndDate}, le résultat a diminué pour {CategoryName}.',
        trend_increased:
          'Au cours de la période {StartDate} - {EndDate}, le résultat a augmenté pour {CategoryName}. Continuez votre bon travail!',
        trend_same:
          'Le résultat est resté le même pour {categoryName} pendant la période {StartDate} - {EndDate}.'
      }
    },
    noTrend: "Il n'y a aucune enquête plus ancienne à laquelle la comparer.",
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Comparé à celui de la précédente enquête du {oldSurveyDate}, le résultat a diminué de {changeInPercent} % pour {tagName}.',
        nps_trend_increased:
          'Comparé à celui de la précédente enquête du {oldSurveyDate}, le résultat a augmenté de {changeInPercent} % pour {tagName}.',
        nps_trend_same:
          'Le résultat est resté à peu près le même ({changeInPercent} % de différence) pour {tagName} depuis la dernière enquête du {oldSurveyDate}.',
        trend_decreased:
          'Pendant la période {StartDate} - {EndDate}, le résultat a diminué pour {tagName}.',
        trend_increased:
          'Pendant la période {StartDate} - {EndDate}, le résultat a augmenté pour {tagName}',
        trend_same:
          'Le résultat est resté le même pour {categoryName} pendant la période {StartDate} - {EndDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Tous les groupes',
    cannotChangeGroupsWhileComparing:
      "L'affichage comparatif vous permet de visualiser plusieurs groupes simultanément.",
    group: 'Groupe',
    segment: 'Segment',
    survey: 'Enquête'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Nombre de personnes ayant sélectionné au moins une action',
      totalActions: "Nombre total d'actions sélectionnées"
    },
    title: 'Résumé des actions'
  },
  widgetAlert: {
    actions: {
      saved: "Merci, l'activité a été sauvegardée,"
    },
    links: {
      tooltip: 'Le lien ouvre dans une nouvelle fenêtre.'
    },
    notEnoughData: "Rien n'est affiché ici pour le moment."
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Dernier signalement {surveyDate}.'
      },
      question: {
        info: 'Dernière question posée concernant la {surveyDate} dans " {surveyTitle} ".'
      }
    },
    notEnoughResponses:
      "Il n'y a pas encore assez de réponses pour afficher quoi que ce soit ici.",
    title: 'Catégories',
    tooltip: {
      value:
        "C'est la valeur moyenne pour toutes les réponses aux questions de {categoryName} auxquelles ont répondu les personnes de {groupName}."
    }
  },
  widgetErrorFallback: {
    description:
      "Une erreur inattendue est survenue lors du chargement du widget. En cours de résolution. Veuillez au préalable essayer de rafraîchir la page. Une erreur inattendue est survenue lors du chargement du widget. En cours Si le problème persiste, veuillez nous le signaler et nous l'examinerons immédiatement. Veuillez d'abord tenter de rafraîchir la page. Une erreur inattendue est survenue lors du chargement du widget. En cours",
    hideErrorDetails: "Masquer les détails de l'erreur",
    showErrorDetails: "Masquer les détails de l'erreur",
    title: 'Problème avec le widget !'
  },
  widgetGroupActions: {
    allCategories: "À l'intérieur de toutes les catégories",
    freeText: {
      alert: {
        noResults:
          'Aucun résultat trouvé. Essayez de saisir une autre information.',
        typeMore: 'Saisir davantage'
      },
      filterField: {
        placeholder: 'Saisir pour trouver les commentaires'
      },
      numberOfComments: '{numberOfComments} commentaires'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title:
          'Comment développer la responsabilité personnelle parmi les employés'
      }
    },
    noActions: 'Aucune action à afficher.',
    noActionsSelectedInCategory: "Aucune action n'a été sélectionnée",
    otherActions: 'Actions propres',
    people: 'aucun | {count} personne | {count} personnes',
    peopleSelectedActions:
      'Sur {peopleResponded} personnes ayant répondu, 1 seule a sélectionné au moins une action ({percentage}%)| Sur {peopleResponded} personnes ayant répondu, {count} personnes ont sélectionné au moins une action ({percentage}%)',
    title: 'Actions pour les personnes à {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 personne a sélectionné cette action| {count} personnes ont sélectionné cette action'
    }
  },
  widgetGroupPriorities: {
    description:
      'Selon les participants du sondage, voici les sujets sur lesquels il faut se concentrer en priorité aujourd’hui.',
    freeTextResponses: 'Montrer les réponses à texte libre',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Comment développer votre équipe avec Pulsᐩ'
      }
    },
    noPriorities: "Les participants n'ont pas choisi de priorités",
    people: 'aucun | {count} personne | {count} personnes',
    thinkImportant: ' pense que "{category}" est le plus important',
    title: 'Priorités des personnes en  {groupName}'
  },
  widgetNotImplemented: {
    content: 'Not implemented yet'
  },
  widgetSurveyInfo: {
    endDate: 'Date de fin:',
    noone: "Aucun n'a répondu",
    notEnoughResponses: {
      aggregate:
        'Le nombre de réponses reçues pendant la période donnée était insuffisant pour obtenir des résultats significatifs.',
      completed:
        "Le nombre de réponses à l'enquête était insuffisant pour obtenir des résultats significatifs.",
      published:
        "Le nombre de personnes ayant répondu à l'enquête est encore insuffisant pour afficher les résultats."
    },
    participation: {
      title: 'Participation'
    },
    startDate: 'Date de début:',
    status: {
      completed: "L'enquête est terminée ! Ce sont les résultats finaux.",
      published:
        "L'enquête est toujours en cours. Les résultats sont préliminaires."
    },
    usersInvited: 'Personnes invitées:',
    usersResponded: 'Les gens ont répondu:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Voici les derniers résultats pour {groupName}.'
    },
    notEnoughResponses:
      "Il n'y a pas encore assez de réponses pour afficher quoi que ce soit ici.",
    title: {
      company: 'Tout {organizationName}'
    },
    tooltip: {
      enps_description:
        "eNPS signifie Employee Net Promoter Score et mesure l'attachement des employés à défendre l'emploi dans leur entreprise.",
      nps_description:
        "NPS signifie Net Promoter Score et est une mesure de la probabilité que les gens recommandent quelque chose à d'autres.",
      nps_detractors: 'Detractors',
      nps_passives: 'Passives',
      nps_promoters: 'Promoters',
      value:
        "C'est la valeur moyenne pour toutes les réponses aux questions marquées avec {tagName} répondu par des personnes dans {groupName}."
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} au fil du temps',
    twoTags: '{tag1} et {tag2}'
  }
}
